import { TaskType } from "@/api.types.v2";

/**
 * Dispatch v2 marker/badge taxonomy. Mirrors `lib/task-colors.ts` but deepens
 * delivery to indigo-violet `#9333EA` (purple-600) for marker legibility, per
 * the redesign HANDOFF (the live `#C084FC` washes out on the map).
 *
 * `lane` collapses the nine task types into the four the rail/markers count by
 * (pickup · delivery · dropoff · return), with depot/carrier-pickup folded into
 * the nearest lane so a stop's chip row stays readable.
 */
export type TaskLane = "pickup" | "delivery" | "dropoff" | "return";

export const LANE_ORDER: TaskLane[] = [
  "pickup",
  "delivery",
  "dropoff",
  "return",
];

export const LANE_META: Record<
  TaskLane,
  { color: string; label: string; short: string }
> = {
  pickup: { color: "#2563EB", label: "Pickups", short: "PU" },
  delivery: { color: "#9333EA", label: "Deliveries", short: "DEL" },
  dropoff: { color: "#16A34A", label: "Drop-offs", short: "DO" },
  return: { color: "#EA580C", label: "Returns", short: "RET" },
};

export function taskLane(type: TaskType): TaskLane {
  switch (type) {
    case TaskType.CUSTOMER_PICKUP:
    case TaskType.CARRIER_PICKUP:
      return "pickup";
    case TaskType.CUSTOMER_DELIVERY:
      return "delivery";
    case TaskType.CUSTOMER_RETURN:
      return "return";
    default:
      return "dropoff";
  }
}

export type LaneCounts = Record<TaskLane, number>;

export function emptyLaneCounts(): LaneCounts {
  return { pickup: 0, delivery: 0, dropoff: 0, return: 0 };
}

/** Directional glyph per lane for the decision-first assign rows. */
export const LANE_DIR: Record<TaskLane, "up" | "down" | "return"> = {
  pickup: "up",
  delivery: "down",
  dropoff: "down",
  return: "return",
};
